"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appActions = require("../appActions");
var _questionnaireActions = require("./questionnaireActions");
var _recommendationActions = require("../recommendation/recommendationActions");
const initialState = {
  questions: [],
  currentQuestionIndex: 0,
  selections: {},
  answers: [],
  handsetSearchList: [],
  budget: {},
  isBudgetAdjusted: false,
  progressBarPercentage: 0,
  questionIndexInFlow: 0,
  isExclusiveSelection: false,
  defaultMetadata: [],
  defaultFlags: [],
  skippedQuestionIds: []
};
const questionnaireReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _questionnaireActions.SET_QUESTIONS:
      return {
        ...state,
        questions: payload.questions
      };
    case _questionnaireActions.GOTO_NEXT_QUESTION:
      {
        const {
          currentQuestionIndex
        } = state;
        const answer = {
          questionIndex: currentQuestionIndex,
          metadata: payload.metadata,
          summary: payload.summary,
          id: payload.id
        };
        return {
          ...state,
          currentQuestionIndex: payload.nextQuestionIndex,
          answers: [...state.answers, answer]
        };
      }
    case _questionnaireActions.GOTO_PREVIOUS_QUESTION:
    case _recommendationActions.GO_BACK_TO_QUESTIONNAIRE:
      {
        const {
          answers
        } = state;
        const previousAnswer = answers[answers.length - 1];
        const previousQuestionIndex = previousAnswer.questionIndex;
        return {
          ...state,
          currentQuestionIndex: previousQuestionIndex,
          answers: answers.slice(0, -1)
        };
      }
    case _recommendationActions.GO_BACK_TO_CURRENT_QUESTION:
      {
        return state;
      }
    case _questionnaireActions.GOTO_QUESTION:
      {
        const questionIndex = state.questions.findIndex(question => question.id === payload.id);
        const answers = state.answers.slice(0, state.answers.findIndex(answer => answer.questionIndex === questionIndex));
        return {
          ...state,
          currentQuestionIndex: questionIndex,
          answers: answers
        };
      }
    case _questionnaireActions.VIEW_QUESTION:
      {
        return {
          ...state,
          viewQuestionIndex: payload.viewQuestionIndex
        };
      }
    case _questionnaireActions.SKIP_QUESTION:
      return {
        ...state,
        currentQuestionIndex: payload.nextQuestionIndex
      };
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return {
        ...state,
        currentQuestionIndex: 0,
        selections: {},
        answers: [],
        budget: []
      };
    case _questionnaireActions.ADD_SELECTION:
      {
        const {
          selections,
          currentQuestionIndex
        } = state;
        if (!selections[currentQuestionIndex]) {
          selections[currentQuestionIndex] = [];
        }
        const newSelections = [...new Set([...selections[currentQuestionIndex], payload.selection])];
        return {
          ...state,
          selections: {
            ...selections,
            [currentQuestionIndex]: newSelections
          }
        };
      }
    case _questionnaireActions.REMOVE_SELECTION:
      {
        var _selections$currentQu;
        const {
          currentQuestionIndex,
          selections
        } = state;
        const newSelections = (_selections$currentQu = selections[currentQuestionIndex]) === null || _selections$currentQu === void 0 ? void 0 : _selections$currentQu.filter(selection => selection !== payload.selection);
        return {
          ...state,
          selections: {
            ...selections,
            [currentQuestionIndex]: newSelections
          }
        };
      }
    case _questionnaireActions.REPLACE_SELECTION:
      {
        const {
          currentQuestionIndex,
          selections
        } = state;
        const currentSelections = selections[currentQuestionIndex];
        return {
          ...state,
          selections: {
            ...selections,
            [currentQuestionIndex]: Object.assign([], currentSelections, {
              [payload.index]: payload.selection
            })
          }
        };
      }
    case _questionnaireActions.RESET_SELECTIONS:
      {
        const {
          currentQuestionIndex,
          selections
        } = state;
        return {
          ...state,
          selections: {
            ...selections,
            [currentQuestionIndex]: []
          }
        };
      }
    case _appActions.INJECT_STATE:
      return {
        ...state,
        ...payload.questionnaire
      };
    case _questionnaireActions.SET_HANDSET_SEARCH_LIST:
      return {
        ...state,
        handsetSearchList: payload.handsetList
      };
    case _questionnaireActions.SET_BUDGET:
      return {
        ...state,
        budget: payload.budget
      };
    case _questionnaireActions.RESET_BUDGET_AND_RECOMMENDATION:
      return {
        ...state,
        budget: {},
        isBudgetAdjusted: false
      };
    case _questionnaireActions.ADJUST_BUDGET:
      return {
        ...state,
        isBudgetAdjusted: payload.budgetAdjusted
      };
    case _questionnaireActions.PROGRESS_BAR_PERCENTAGE:
      return {
        ...state,
        progressBarPercentage: payload.percentage
      };
    case _questionnaireActions.SET_QUESTION_INDEX_IN_FLOW:
      return {
        ...state,
        questionIndexInFlow: payload
      };
    case _questionnaireActions.SET_IS_EXCLUSIVE_SELECTION:
      return {
        ...state,
        isExclusiveSelection: payload
      };
    case _questionnaireActions.SET_METADATA:
      return {
        ...state,
        defaultMetadata: payload.metadata
      };
    case _questionnaireActions.SET_FLAGS:
      return {
        ...state,
        defaultFlags: payload.flags
      };
    case _questionnaireActions.SET_SKIPPED_QUESTION_IDS:
      return {
        ...state,
        skippedQuestionIds: payload.skippedQuestionIds
      };
    default:
      return state;
  }
};
var _default = questionnaireReducer;
exports.default = _default;